import { render, staticRenderFns } from "./TableSortingField.vue?vue&type=template&id=bd5e0d5a&"
import script from "./TableSortingField.vue?vue&type=script&lang=js&"
export * from "./TableSortingField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports